import { PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit'

export enum PaymentInfoTypeE {
  LOYALTY_ALREADY_PURCHASED = 'LOYALTY_ALREADY_PURCHASED',
}

export interface IPaymentInfo {
  image: string
  message: string
}

export interface IPaymentState {
  loading: boolean
  info: PaymentInfoTypeE | null
}

export interface IPaymentReducers extends SliceCaseReducers<IPaymentState> {
  checkBalanceAfterConnect: (
    state: IPaymentState,
    action: PayloadAction<{ contractAddress: string; address: string }>
  ) => void
  setPaymentInfo: (state: IPaymentState, action: PayloadAction<{ info: PaymentInfoTypeE }>) => void
  clearPaymentInfo: (state: IPaymentState) => void
}
